import i18next from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

// English Name Spaces
import english from './english'

// Spanish Name Spaces
import spanish from "./spanish"

// French Name Spaces
import french from "./french"

export const defaultNS = "enLogInSignUp"

i18next.use(LanguageDetector).use(initReactI18next).init({
    resources: {
        en: english,
        es: spanish,
        fr: french,
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    debug: false,
})